import styled from 'styled-components';

import Header from './Header';
import Section from './Section';

const SignInPage: any = styled('div')``;

SignInPage.Section = Section;
SignInPage.Header = Header;

export default SignInPage;
